module.exports = __webpack_public_path__ + "assets/img/4april_light.f380892b.jpeg";